import { render, staticRenderFns } from "./AreasModal.vue?vue&type=template&id=40660471&scoped=true&"
import script from "./AreasModal.vue?vue&type=script&lang=js&"
export * from "./AreasModal.vue?vue&type=script&lang=js&"
import style0 from "./AreasModal.vue?vue&type=style&index=0&id=40660471&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40660471",
  null
  
)

export default component.exports